import dayjs from 'dayjs'
import React from 'react'
import { ReportsTableItem } from '../styledComponents'
import { getFeeMapString } from '../utils'
import {} from './ClinicReportComponent'
import { renderIntegerDivForClinicReport } from './OverallReportComponent'

function renderFeeRelatedDataForClinicReport(currencyToFeeCollectedMap) {
  if (!currencyToFeeCollectedMap) return <div className="report-item">NA</div>

  const stringToView = getFeeMapString({ currencyToFeeCollectedMap: currencyToFeeCollectedMap })

  return <div className="report-item">{stringToView}</div>
}

export default function PatientVisitReport({
  metricData,
  reportEndTime,
  reportStartTime,
  getCorrectReportDateString,
  showPaymentRelatedData,
}) {
  return (
    <ReportsTableItem columns={showPaymentRelatedData ? 5 : 4}>
      <div className="reports-top-header">
        {reportEndTime &&
          getCorrectReportDateString(
            dayjs.utc(reportEndTime).local(),
            dayjs.utc(reportStartTime).local(),
          )}
      </div>
      {renderIntegerDivForClinicReport(metricData?.totalBookedCount)}
      {renderIntegerDivForClinicReport(metricData?.newBookedCount)}
      {renderIntegerDivForClinicReport(metricData?.repeatBookedCount)}
      {showPaymentRelatedData &&
        renderFeeRelatedDataForClinicReport(metricData?.currencyToFeeCollectedMap)}
    </ReportsTableItem>
  )
}
